import { ImageType, DEFAULT_IMAGE_DIMENSIONS } from "utils/imageConstants";
import { Client } from "./_clientService";

/** The three logo slots an operator must provide. Keys match the backend. */
export const OPERATOR_LOGO_SLOTS = [
  "desktopStacked",
  "ftueInitial",
  "inGameTop",
] as const;

export type OperatorLogoSlot = (typeof OPERATOR_LOGO_SLOTS)[number];

export interface OperatorLogoSlotMeta {
  key: OperatorLogoSlot;
  label: string;
  placement: string;
  style: string;
  imgType?: ImageType;
  helperText?: string;
}

export const OPERATOR_LOGO_SLOT_META: OperatorLogoSlotMeta[] = [
  {
    key: "desktopStacked",
    label: "Desktop (Top-Left)",
    placement: "Desktop top-left",
    style: "Football Logo Primary Stacked",
    imgType: ImageType.OPERATOR_LOGO_DESKTOP_STACKED,
    helperText: `Accepted formats: .PNG, .SVG. Max size: 2 MB. Higher resolution images will be automatically resized to fit ${DEFAULT_IMAGE_DIMENSIONS[ImageType.OPERATOR_LOGO_DESKTOP_STACKED].width} x ${DEFAULT_IMAGE_DIMENSIONS[ImageType.OPERATOR_LOGO_DESKTOP_STACKED].height} pixels.`

  },
  {
    key: "ftueInitial",
    label: "FTUE Initial Screen",
    placement: "FTUE initial screen",
    style: "Football Logo Primary Long",
    imgType: ImageType.OPERATOR_LOGO_FTUE_INITIAL,
    helperText: `Accepted formats: .PNG, .SVG. Max size: 2 MB. Higher resolution images will be automatically resized to fit ${DEFAULT_IMAGE_DIMENSIONS[ImageType.OPERATOR_LOGO_FTUE_INITIAL].width} x ${DEFAULT_IMAGE_DIMENSIONS[ImageType.OPERATOR_LOGO_FTUE_INITIAL].height} pixels.`
  },
  {
    key: "inGameTop",
    label: "In-Game (Top)",
    placement: "In-game top",
    style: "Football Logo Primary Long",
    imgType: ImageType.OPERATOR_LOGO_IN_GAME_TOP,
    helperText: `Accepted formats: .PNG, .SVG. Max size: 2 MB. Higher resolution images will be automatically resized to fit ${DEFAULT_IMAGE_DIMENSIONS[ImageType.OPERATOR_LOGO_IN_GAME_TOP].width} x ${DEFAULT_IMAGE_DIMENSIONS[ImageType.OPERATOR_LOGO_IN_GAME_TOP].height} pixels.`
  },
];

async function getOperatorLogos() {
  return new (Client as any)({ path: "/operator-logo/list" }).get();
}

async function getOperatorLogo(operatorId: string) {
  return new (Client as any)({ path: `/operator-logo/${operatorId}` }).get();
}

async function createOperatorLogos(operatorId: string, formData: FormData) {
  return new (Client as any)({
    path: `/operator-logo/${operatorId}`,
    payload: formData,
  }).post();
}

async function replaceOperatorLogo(
  operatorId: string,
  slot: OperatorLogoSlot,
  formData: FormData,
) {
  return new (Client as any)({
    path: `/operator-logo/${operatorId}/${slot}`,
    payload: formData,
  }).put();
}

async function deleteOperatorLogos(operatorId: string) {
  return new (Client as any)({ path: `/operator-logo/${operatorId}` }).delete();
}

export {
  getOperatorLogos,
  getOperatorLogo,
  createOperatorLogos,
  replaceOperatorLogo,
  deleteOperatorLogos,
};